module.exports = __webpack_public_path__ + "static/media/leaf_3.7dcb5616.png";